import React from 'react';
import {
  createNativeStackNavigator,
  NativeStackNavigationProp,
} from '@react-navigation/native-stack';
import {useTheme} from 'contexts/ThemeContext';
import {Flows, ScreenName, Screens} from './Screens';
import HeaderBackButton from 'components/atoms/headerBackButton';
import strings from '../translations';
import styleSheet from './styles';
import {RouteProp} from '@react-navigation/native';
import {Platform} from 'react-native';
import GroupsFlow from './GroupsFlow';

const Stack = createNativeStackNavigator();

export interface AdminPanelGeneralScreenProps {
  navigation: NativeStackNavigationProp<{
    [ScreenName.adminPanelGeneral]: undefined;
    [ScreenName.adminPanelTeachers]: undefined;
    [Flows.adminPanelGroupsFlow]: undefined;
  }>;
}

const AdminFlow = () => {
  const theme = useTheme();
  const styles = styleSheet(useTheme());

  return (
    <Stack.Navigator
      screenOptions={({navigation, route}) => ({
        headerLeft: () => <HeaderBackButton onPress={() => navigation.pop()} />,
        headerStyle: styles.headerStyle,
        headerTitleStyle: styles.headerTitleStyle,
        headerTitleAlign: 'center',
        headerShadowVisible: false,
      })}>
      <Stack.Screen
        name={Screens.AdminPanelGeneralScreen.name}
        component={Screens.AdminPanelGeneralScreen.screen}
        options={{headerShown: false}}
      />
      <Stack.Screen
        name={Screens.AdminPanelTeachersScreen.name}
        component={Screens.AdminPanelTeachersScreen.screen}
        options={{headerShown: false}}
      />
      <Stack.Screen
        name={Flows.adminPanelGroupsFlow}
        component={GroupsFlow}
        options={{headerShown: false}}
      />
    </Stack.Navigator>
  );
};

export default AdminFlow;
